import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

const SearchIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 25 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 16.5C14.3137 16.5 17 13.8137 17 10.5C17 7.18629 14.3137 4.5 11 4.5C7.68629 4.5 5 7.18629 5 10.5C5 13.8137 7.68629 16.5 11 16.5ZM11 18C15.1421 18 18.5 14.6421 18.5 10.5C18.5 6.35786 15.1421 3 11 3C6.85786 3 3.5 6.35786 3.5 10.5C3.5 14.6421 6.85786 18 11 18Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.7197 15.2197C16.0126 14.9268 16.4874 14.9268 16.7803 15.2197L20.5303 18.9697C20.8232 19.2626 20.8232 19.7374 20.5303 20.0303C20.2374 20.3232 19.7626 20.3232 19.4697 20.0303L15.7197 16.2803C15.4268 15.9874 15.4268 15.5126 15.7197 15.2197Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default SearchIcon;
